import React from "react";
import { useParams } from "react-router-dom";
import { fetchWorkOrderPaymetDetails } from "../../services/api/workOrder";
import { useQuery } from "@tanstack/react-query";
import useAuth from "../../hooks/useAuth";
import { UserType } from "../../utils/enum";
import { isVendorTech } from "../../utils/helpers";

const PaymentCard = ({ totalAmount, status, hideAmount = false }) => {
  const { id } = useParams();
  const { authRole, auth } = useAuth();

  const {
    isLoading,
    error,
    data: workOrderPaymentData,
  } = useQuery({
    queryKey: ["workOrderPayment"],
    queryFn: () => fetchWorkOrderPaymetDetails(id),
    enabled: !!id && !isVendorTech(auth?.user),
  });

  // A customer is billed on the client rates, so that — not the engineer's pay —
  // is the figure that belongs to them. The API returns clientRates alone to a
  // customer and never includes engineerRates, which is why the amount used to be
  // hidden from them entirely.
  const payment =
    authRole === UserType.CUSTOMER
      ? workOrderPaymentData?.data?.clientRates
      : workOrderPaymentData?.data?.engineerRates;

  return (
    <div className="shadow-md rounded-md py-3 px-4 h-full">
      <div className="flex">
        <i className="fa-light fa-coins text-3xl text-primary"></i>
        <div className="ml-2  mt-2">
          <p className="font-normal text-sm text-dark">Payment: {status}</p>

          {!hideAmount && !isVendorTech(auth?.user) && (
            <p className="text-sm mt-1 text-primary">
              {`${payment?.currency} `}
              {status === "Pending"
                ? payment?.grandTotal?.toFixed(2)
                : payment?.totalWorkOrderCost?.toFixed(2)}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentCard;
